var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1961 4.01362L6.55044 0.723449C6.22064 0.489883 5.77936 0.489883 5.44956 0.723449L0.803891 4.01362C0.299682 4.37071 0 4.95018 0 5.56804V11.7622C0 12.8142 0.852791 13.667 1.90476 13.667H3.33333C3.85932 13.667 4.28571 13.2406 4.28571 12.7146V11.286C4.28571 10.76 4.71211 10.3336 5.23809 10.3336H6.7619C7.28789 10.3336 7.71429 10.76 7.71429 11.286V12.7146C7.71429 13.2406 8.14068 13.667 8.66667 13.667H10.0952C11.1472 13.667 12 12.8142 12 11.7622V5.56803C12 4.95018 11.7003 4.37071 11.1961 4.01362Z",
    fill: "#1DA1F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.02c1553a34b2e3517c2b3de5519438ef.svg";
export { ForwardRef as ReactComponent };